import * as React from 'react'
import Stack from '@mui/material/Stack'
import { DraftLead } from '@user/store/draftLeads'
import Box from '@mui/material/Box'
import { blurbTextLead, blurbTextLeadNonWeb, WebFormButton } from '..'
import format from 'date-fns/format'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { AddLeadHeaderContainer } from '@sales-center/components'
import Typography from '@mui/material/Typography'
import { Theme } from '@mui/material/styles'
import { EntityRecordTypes } from '@user/features/EntityDetails/components/EntityDetailsAdditionalInformation/typings'

type Props = {
  draftLead?: DraftLead
}

export function WebFormHeader(props: Props) {
  const { draftLead } = props
  const dateFormatted = draftLead?.createdTime
    ? format(new Date(draftLead.createdTime), 'MM/dd/yy')
    : '-'

  const typeWeb = draftLead?.type?.toLowerCase() === EntityRecordTypes.web
  const typeImport = draftLead?.type?.toLowerCase() === EntityRecordTypes.import

  return (
    <AddLeadHeaderContainer
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack direction="row">
        <InfoOutlined
          sx={{
            color: '#0288d1',
            fontSize: '22px',
            marginRight: (theme: Theme) => theme.spacing(1.5),
          }}
        />
        <Typography
          sx={{
            color: '#013654',
            letterSpacing: '0.17px',
            lineHeight: '23px',
          }}
        >
          {typeWeb ? blurbTextLead : blurbTextLeadNonWeb}
        </Typography>
      </Stack>
      {!typeImport && draftLead && (
        <Box>
          <WebFormButton
            type={draftLead.type}
            draftLeadId={draftLead.id}
            createdTime={dateFormatted}
            submittedBy={draftLead.submittedBy}
            noIcon
            variant="button-small"
            webFormCallTrackingEventId={draftLead.webFormCallTrackingEventId}
            text={
              typeWeb ? 'View Submitted Webform' : 'View Captured Information'
            }
          />
        </Box>
      )}
    </AddLeadHeaderContainer>
  )
}
